'use client';
import { FC, ReactNode } from 'react';
import { usePathname } from 'next/navigation';
const HeaderTags: FC<{ children?: ReactNode }> = ({ children }) => {
  const pathname = usePathname();
  const baseUrl = 'https://shibthemetaverse.io';
  const canonicalUrl = `${baseUrl}${pathname}`;
  return (
    <head id="app">
      <link rel="canonical" href={canonicalUrl} />
      {children}
    </head>
  );
};
export default HeaderTags;
